import React, {PureComponent} from "react";
import {Field, reduxForm} from "redux-form";
import createOnSubmitFailHandler from "../../Form/createOnSubmitFailHandler.js";

import PropTypes from "prop-types";
import validate from './validate.js';
import Input from "../../Form/Field/Input.jsx";

export const name = 'FreelanceInterviewSummaryStepForm';

class SummaryStepForm extends PureComponent {
  static propTypes = {
    counter: PropTypes.number,
  }

  static defaultProps = {
    counter: 1300
  }

  constructor(props) {
    super(props);
    this.state = {
      counter: props.counter - (props.initialValues.freelance.summary ? props.initialValues.freelance.summary.length : 0),
    }
  }

  handleSummaryChange = (e) => {
    const _c = this.props.counter - e.target.value.length;
    this.setState({
      counter: _c < 0 ? 0 : _c,
    });
  }

  limiter = (value) => {
    if(value.length > this.props.counter) {
      return value.substring(0, this.props.counter);
    }

    return value
  }
  
  render() {
    return(
      <div id={name}>
        <form autoComplete="off" onSubmit={this.props.handleSubmit}>
          <div className="row">
            <div className="col-md-12">
              <Field
                label={"Décrivez vous et vos attentes, en quelques lignes"}
                name="freelance.summary"
                component={Input}
                type="textarea"
                onChange={this.handleSummaryChange}
                counter={this.state.counter}
                normalize={this.limiter}
              />
            </div>
          </div>
          <div className="col-lg-12"><input className="d-none" type="submit" /></div>
        </form>
      </div>)

  }
}

export default reduxForm({
  form: name,
  onSubmitFail: createOnSubmitFailHandler(name),
  validate
})(SummaryStepForm);